import { axiosInstance } from './req';
import { UserInfo, AuthToken, PasswordChangeInfo } from '@/types/user-info';
import { userObj } from '@/utils/users';

export const login = async (
    username: string,
    password: string,
    twoFactorCode?: string,
): Promise<{
    user?: UserInfo;
    authToken?: AuthToken;
    twoFactorCodeRequired?: boolean;
}> => {
    return axiosInstance.post('/api/login', { username, password, twoFactorCode }).then(({ data }) => {
        if (data.twoFactorCodeRequired) return data;
        return {
            authToken: data.authHeader,
            user: userObj(data),
        };
    });
};

export const signup = async (
    name: string,
    email: string,
    password: string,
    country: string,
    currency: string,
): Promise<{
    user?: UserInfo;
    authToken?: AuthToken;
    twoFactorCodeRequired?: boolean;
}> => {
    return axiosInstance.post('/api/signup', { name, email, country, currency, password }).then(({ data }) => {
        return {
            authToken: data.authHeader,
            user: userObj(data),
        };
    });
};

export const k9Register = async (
    name: string,
    email: string,
    country: string,
    currency: string,
): Promise<{ message: string }> => {
    return axiosInstance.post('/api/k9/register', { name, email, country, currency }).then(({ data }) => data);
};

export const resetPassword = async (email: string): Promise<void> => {
    return axiosInstance.post('/api/login/forgot', { email }).then(({ data }) => data);
};

export const resendVerificationEmail = async (email: string): Promise<void> => {
    return axiosInstance.post('/api/v2/account/resend-verification-email', { email }).then(({ data }) => data);
};

export const setNewPassword = async (token: string, password: string, confirmation: string): Promise<void> => {
    return axiosInstance.post(`/api/login/reset/${token}`, { password, confirmation }).then(({ data }) => data);
};

export const verifyEmail = async (token: string): Promise<void> => {
    return axiosInstance.post(`/api/login/reset/${token}`).then(({ data }) => data);
};

export const twoFactorAuthInit = async (): Promise<{ twoFactorToken: string }> => {
    return axiosInstance.post('/api/v2/account/2fa/init').then(({ data }) => data);
};

export const twoFactorAuthVerify = async ({ token }: { token: string }): Promise<{ success: boolean }> => {
    return axiosInstance.post(`/api/v2/account/2fa/verify/${token}`).then(({ data }) => data);
};

export const twoFactorAuthUnlink = async (): Promise<void> => {
    return axiosInstance.delete(`/api/v2/account/2fa`).then(({ data }) => data);
};

export const updatePassword = async (passwordChange: PasswordChangeInfo): Promise<void> => {
    return axiosInstance.put(`/api/v2/account/password`, passwordChange).then(({ data }) => data);
};

export const updateEmail = async (email: string): Promise<{ updatedUser?: UserInfo }> => {
    return axiosInstance.put(`/api/v2/account/email`, { email }).then(({ data }) => {
        return {
            updatedUser: userObj(data),
        };
    });
};

export const generateClientAPIKey = async () => {
    return axiosInstance.post(`/api/v2/account/clientKey`).then(({ data }) => data);
};

export const updateClientAPIKey = async (active: boolean) => {
    return axiosInstance.put(`/api/v2/account/clientKey`, { active }).then(({ data }) => data);
};

export const fetchClientAPIKey = async () => {
    return axiosInstance.get(`/api/v2/account/clientKey`).then(({ data }) => data);
};

export const removeClientAPIKey = async () => {
    return axiosInstance.delete(`/api/v2/account/clientKey`).then(({ data }) => data);
};
